﻿import Cookies from "js-cookie"

const emergencyBannerClosedCookieKey = "emergencyBannerClosed"

export const emergencyBanner = () => {
  const closeEmergencyBanner = () => {
    // Select the emergency banner if present. Assumes that there is only one emergency banner.
    const banner = document.querySelector(".emergency-banner");
    if (banner) {
      banner.classList.add("!h-0");
      // Sets a cookie to use in SSR.
      Cookies.set(emergencyBannerClosedCookieKey, `${banner.id};${new Date().toISOString()}`, { expires: 14 });
    }
  };
  // Select the emergency banner close button if present. Assumes that there is only one emergency banner.
  document
    .querySelector(".emergency-banner__close-button")?.addEventListener("click", closeEmergencyBanner);
};